"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
exports.Constants = {
    API_DEBOUNCE_DELAY_IN_MS: 300,
    HHN_DATE_FORMAT: "MM/DD/YYYY",
    HHN_TIME_FORMAT: "HH:mm",
    FOCUS_HIGHLIGHT_DURATION_IN_MS: 500,
    SCROLL_TO_INDEX_MAX_RETRIES: 5,
    SCROLL_TO_INDEX_RETRY_DELAY_IN_MS: 200,
    ORG_ID_KEY: "organizationId",
};
